var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpt-load-error"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_vm._v("There was an error loading the application.")]),_c('p',{staticClass:"subtitle"},[_vm._v("Kymeta Support has been notified. Please try refreshing the page.")])])])
}]

export { render, staticRenderFns }